import { useQuery } from 'react-query';
import { shallow } from 'zustand/shallow';
import usePlanStore from 'store/planStore';
import { Countries } from 'shared/enums';
import { getTouchpoints } from 'api/services/mediaPlanning/touchpoints';
import { useError } from 'pages/calculator/MediaPlanning/common/Errors/ErrorContext/ErrorContext';

const LIVE_TOUCHPOINTS_KEY = 'live-touchpoints';

const useLiveTouchpoints = () => {
  const { generalInfoState, selectedCountryISOCode } = usePlanStore();
  const { showError } = useError();

  const liveFormSubset = usePlanStore((state) => {
    const form = state.countryForms[state.selectedCountry!];
    return form
      ? {
          targetGroup: form.targetGroup,
          campaignScenario: form.campaignScenario,
        }
      : null;
  }, shallow);

  const { data: response, isFetching } = useQuery(
    [
      LIVE_TOUCHPOINTS_KEY,
      selectedCountryISOCode,
      generalInfoState.division,
      generalInfoState.brand,
      generalInfoState.category,
      liveFormSubset,
    ],
    () =>
      getTouchpoints(
        generalInfoState.division,
        generalInfoState.brand,
        generalInfoState.category,
        selectedCountryISOCode as Countries,
        liveFormSubset!.targetGroup,
        liveFormSubset!.campaignScenario
      ),
    {
      enabled:
        !!selectedCountryISOCode &&
        !!generalInfoState.division &&
        !!liveFormSubset?.targetGroup &&
        !!liveFormSubset?.campaignScenario,
      onError: (error: any) => {
        const errorMessage =
          error?.response?.data?.message || error.message || 'Unknown error';
        showError(errorMessage);
      },
    }
  );

  return { data: response?.data ?? [], isFetching };
};

export default useLiveTouchpoints;
